export const PSICommissionTypeEnum = {
  Percentage:
  {
    key: 1,
    name: 'Percentage',
    value: 1 , 
    title : 'Flat Rate (%)'

  },
  FixedAmount: {
    key: 2,
    name: 'Fixed Amount',
    value: 2 ,
    title : 'Fixed Commission (AED)'

  },
  Slab: {
    key: 3,
    name: 'Slab',
    value: 3,
    title : 'Tiered Commission (Slab)' 
  },
};
